import { Link } from "@mui/material";
import Box from "@mui/material/Box";
import { GridCellParams, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import chroma from "chroma-js";
import React from "react";
const scale = chroma.scale([
  "rgba(0,0,255,0.5)",
  "#C2C2C2",
  "rgba(255,0,0,0.5)",
]);


const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#073060ff", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#61b8ffff", "#FFFFFF"],
  DET: ["#0C2C56", "#f62e23ff", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#143680ff", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#be8e14ff", "#FFFFFF"],
  STL: ["#BE0A15", "#b6b31bff", "#FFFFFF"],
  LAD: ["#005A9D", "#005184ff", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#000000ff", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export const hitter_columns: GridColDef<any>[] = [
  {
    field: "batter_name",
    headerName: "Name",
    width: 180,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          <Link href={"/afl/player/" + params.row.id} underline="hover">
            {params.value}
          </Link>
        </Box>
      );
    },
  }, {
    field: "afl_team",
    headerName: "AFL Team",
    width: 100,
    valueGetter: (value: any) => {
      return value !== "0" && value !== 0 ? value.toString() : "FA";
    },
    valueFormatter: (value: any) => {
      return value !== "0" && value !== 0 ? value : "FA";
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = teamColors[params.value][0]

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow: "-1px -1px 0 " + teamColors[params.value][1] + ", 1px -1px 0 " + teamColors[params.value][1] + ", -1px 1px 0 " + teamColors[params.value][1] + ", 1px 1px 0 " + teamColors[params.value][1] + "",
          }}
        >
          {(params.value)}
        </Box>
      );
    },
  },
  {
    field: "MLB_AbbName",
    headerName: "Org",
    width: 60,
    valueGetter: (value: any) => {
      return value !== "0" && value !== 0 ? value.toString() : "FA";
    },
    valueFormatter: (value: any) => {
      return value !== "0" && value !== 0 ? value : "FA";
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = params.value?teamColors[params.value][0]: "#FFFFFF"

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: params.value? teamColors[params.value][2]: "#000000",
            textShadow: "-1px -1px 0 " + teamColors[params.value][1] + ", 1px -1px 0 " + teamColors[params.value][1] + ", -1px 1px 0 " + teamColors[params.value][1] + ", 1px 1px 0 " + teamColors[params.value][1] + "",
          }}
        >
          {(params.value)}
        </Box>
      );
    },
  },
  { field: "Position", headerName: "Pos", width: 80 },
  { field: "age", headerName: "Age", width: 60 },
  { field: "pa", headerName: "PA", width: 60 },
  { field: "ab", headerName: "AB", width: 60 },
  {
    field: "ba", headerName: "BA", width: 60, valueFormatter: (value: number) => {
      return value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "obp", headerName: "OBP", width: 60, valueFormatter: (value: number) => {
      return value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "slg", headerName: "SLG", width: 60, valueFormatter: (value: number) => {
      return value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "ops", headerName: "OPS", width: 80, valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "woba", headerName: "wOBA", width: 80, 
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.woba_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value >= 1 ? params.value.toFixed(3).toString() : params.value.toFixed(3).toString().substring(1)}
        </Box>
      );
    },
  },
  {
    field: "iso", headerName: "ISO", width: 80,
    valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.iso_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value >= 1 ? params.value.toFixed(3).toString() : params.value.toFixed(3).toString().substring(1)}
        </Box>
      );
    },
  },
  {
    field: "bat_speed", headerName: "Bat Speed", width: 90, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(2) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.bat_speed_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(2) : '-'}
        </Box>
      );
    },
  },
  {
    field: "ev", headerName: "EV", width: 90, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.ev_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "max_ev", headerName: "Max EV", width: 90, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.max_ev_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "max_distance", headerName: "Max Dist", width: 100,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? value.toFixed(0) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.max_distance_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined && params.value.toString() !== '-' ? params.value.toFixed(0) : '-'}
        </Box>
      );
    },
  },
  {
    field: "k_percent", headerName: "K%", width: 90, valueFormatter: (value: number) => {
      return (100 * value).toFixed(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.k_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "bb_percent", headerName: "BB%", width: 90, valueFormatter: (value: number) => {
      return (100 * value).toFixed(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.bb_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "whiff_rate", headerName: "Whiff%", width: 90, valueFormatter: (value: number) => {
      return (100 * value).toFixed(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.whiff_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "hard_hit_rate", headerName: "Hard Hit%", width: 100,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.hard_hit_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined && params.value.toString() !== '-' ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "sweet_spot_rate", headerName: "Sweet Spot%", width: 120,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.sweet_spot_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined && params.value.toString() !== '-' ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "barrel_rate",
    headerName: "Barrel%",
    width: 90,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.barrel_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "chase_rate",
    headerName: "Chase%",
    width: 90,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.chase_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "zcontact_rate",
    headerName: "ZContact%",
    width: 90,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.zcontact_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "zswing_rate",
    headerName: "ZSwing%",
    width: 90,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.zswing_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "avg_launch_angle",
    headerName: "LA",
    width: 80,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-' ? value.toFixed(1) : '-';
    }
  },
  {
    field: "swing_rate",
    headerName: "Swing%",
    width: 90,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    }
  },
  {
    field: "contact_rate",
    headerName: "Contact%",
    width: 100,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    }
  },
  { field: "bb", headerName: "BB", width: 90 },
  { field: "h", headerName: "Hits", width: 90 },
  { field: "k", headerName: "K", width: 90 },
  { field: "total_swings", headerName: "Swings", width: 90 },
  { field: "total_whiffs", headerName: "Whiffs", width: 90 },
  { field: "total_zswings", headerName: "Z-Swings", width: 90 },
  { field: "total_chases", headerName: "Chases", width: 90 },
  { field: "total_zone_pitches", headerName: "Zone Pitches", width: 120 },
  { field: "total_out_of_zone", headerName: "Out of Zone Pitches", width: 150 },

];

export const pitcher_columns: GridColDef<any>[] = [
  {
    field: "pitcher_name",
    headerName: "Name",
    width: 180,
    renderCell: (params: GridRenderCellParams) => (
      <Box sx={{ width: "100%", height: "100%", textAlign: "center" }}>
        <Link href={"/afl/player/" + params.row.id} underline="hover">
          {params.value}
        </Link>
      </Box>
    ),
  },
  {
    field: "afl_team",
    headerName: "AFL Team",
    width: 100,
    valueGetter: (value: any) =>
      value !== "0" && value !== 0 ? value.toString() : "FA",
    valueFormatter: (value: any) =>
      value !== "0" && value !== 0 ? value : "FA",
    renderCell: (params: GridRenderCellParams) => {
      const color = teamColors[params.value][0];
      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow:
              "-1px -1px 0 " +
              teamColors[params.value][1] +
              ", 1px -1px 0 " +
              teamColors[params.value][1] +
              ", -1px 1px 0 " +
              teamColors[params.value][1] +
              ", 1px 1px 0 " +
              teamColors[params.value][1],
          }}
        >
          {params.value}
        </Box>
      );
    },
  },
  {
    field: "MLB_AbbName",
    headerName: "Org",
    width: 60,
    valueGetter: (value: any) =>
      value !== "0" && value !== 0 ? value.toString() : "FA",
    valueFormatter: (value: any) =>
      value !== "0" && value !== 0 ? value : "FA",
    renderCell: (params: GridRenderCellParams) => {
      const color = teamColors[params.value][0];
      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow:
              "-1px -1px 0 " +
              teamColors[params.value][1] +
              ", 1px -1px 0 " +
              teamColors[params.value][1] +
              ", -1px 1px 0 " +
              teamColors[params.value][1] +
              ", 1px 1px 0 " +
              teamColors[params.value][1],
          }}
        >
          {params.value}
        </Box>
      );
    },
  },
  { field: "Position", headerName: "Pos", width: 80 },
  { field: "age", headerName: "Age", width: 60 },
  { field: "pa", headerName: "BF", width: 60 },

  // --- Pitching / Stat Columns ---
  { field: "weighted_psStuff", headerName: "psStuff+", width: 110, valueFormatter: (v: number) => v?.toFixed(1), 
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.weighted_psStuff_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(params.value).toFixed(1)}
        </Box>
      );
    },
   },
  {
    field: "k_percent", headerName: "K%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.k_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "whiff_rate", headerName: "Whiff%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.whiff_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "bb_percent", headerName: "BB%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.bb_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "max_velo", headerName: "Max Velo", width: 90, valueFormatter: (v: number) => v?.toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.max_velo_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value?.toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "barrel_rate", headerName: "Barrel%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.barrel_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "hard_hit_rate", headerName: "HardHit%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.hard_hit_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "woba", headerName: "wOBA", width: 80,
    valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.woba_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value >= 1 ? params.value.toFixed(3).toString() : params.value.toFixed(3).toString().substring(1)}
        </Box>
      );
    },
  },
  {
    field: "ev", headerName: "EV", width: 90, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.ev_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "swinging_strike_rate", headerName: "SwStr%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.swinging_strike_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "chase_rate",
    headerName: "Chase%",
    width: 90,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.chase_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  { field: "avg_launch_angle", headerName: "LA°", width: 80, valueFormatter: (v: number) => v },
  { field: "k_bb_ratio", headerName: "K/BB", width: 80, valueFormatter: (v: number) => v },
  { field: "ground_ball_rate", headerName: "GB%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "fly_ball_rate", headerName: "FB%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "line_drive_rate", headerName: "LD%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "swing_rate", headerName: "Swing%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  
  { field: "babip", headerName: "BABIP", width: 80, valueFormatter: (v: number) => v.toString() !== '-' ? v?.toFixed(3).toString().substring(1): "-"  },
  { field: "pitches_per_pa", headerName: "Pit/PA", width: 80, valueFormatter: (v: number) => v?.toFixed(2) },
  { field: "strike_rate", headerName: "Strike%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "called_strike_rate", headerName: "CStr%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1) },

  // --- Counting stats ---
  { field: "total_pitches", headerName: "Pitches", width: 90 },
  { field: "strikes", headerName: "Strikes", width: 80 },
  { field: "balls", headerName: "Balls", width: 80 },
  { field: "called_strikes", headerName: "Called Str", width: 90 },
  { field: "swinging_strikes", headerName: "Sw Str", width: 90 },
  { field: "total_swings", headerName: "Swings", width: 90 },
  { field: "total_whiffs", headerName: "Whiffs", width: 90 },
  { field: "bb", headerName: "BB", width: 70 },
  { field: "h", headerName: "Hits", width: 70 },
  { field: "k", headerName: "K", width: 70 },
  { field: "hr", headerName: "HR", width: 70 },
];


export const hitter_columns_mobile: GridColDef<any>[] = [
  {
    field: "batter_name",
    headerName: "Name",
    width: 180,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          <Link href={"/afl/player/" + params.row.id} underline="hover">
            {params.value}
          </Link>
        </Box>
      );
    },
  }, {
    field: "afl_team",
    headerName: "AFL Team",
    width: 120,
    valueGetter: (value: any) => {
      return value !== "0" && value !== 0 ? value.toString() : "FA";
    },
    valueFormatter: (value: any) => {
      return value !== "0" && value !== 0 ? value : "FA";
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = teamColors[params.value][0]

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow: "-1px -1px 0 " + teamColors[params.value][1] + ", 1px -1px 0 " + teamColors[params.value][1] + ", -1px 1px 0 " + teamColors[params.value][1] + ", 1px 1px 0 " + teamColors[params.value][1] + "",
          }}
        >
          {(params.value)}
        </Box>
      );
    },
  },
  {
    field: "MLB_AbbName",
    headerName: "Org",
    width: 70,
    valueGetter: (value: any) => {
      return value !== "0" && value !== 0 ? value.toString() : "FA";
    },
    valueFormatter: (value: any) => {
      return value !== "0" && value !== 0 ? value : "FA";
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = params.value !== undefined ? teamColors[params.value][0]: "#FFFFFF"

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow: "-1px -1px 0 " + teamColors[params.value][1] + ", 1px -1px 0 " + teamColors[params.value][1] + ", -1px 1px 0 " + teamColors[params.value][1] + ", 1px 1px 0 " + teamColors[params.value][1] + "",
          }}
        >
          {(params.value)}
        </Box>
      );
    },
  },
  { field: "Position", headerName: "Pos", width: 80 },
  { field: "age", headerName: "Age", width: 80 },
  { field: "pa", headerName: "PA", width: 80 },
  { field: "ab", headerName: "AB", width: 80 },
  {
    field: "ba", headerName: "BA", width: 80, valueFormatter: (value: number) => {
      return value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "obp", headerName: "OBP", width: 80, valueFormatter: (value: number) => {
      return value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "slg", headerName: "SLG", width: 80, valueFormatter: (value: number) => {
      return value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "ops", headerName: "OPS", width: 110, valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
  },
  {
    field: "woba", headerName: "wOBA", width: 110,
    valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.woba_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value >= 1 ? params.value.toFixed(3).toString() : params.value.toFixed(3).toString().substring(1)}
        </Box>
      );
    },
  },
  {
    field: "iso", headerName: "ISO", width: 80,
    valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.iso_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value >= 1 ? params.value.toFixed(3).toString() : params.value.toFixed(3).toString().substring(1)}
        </Box>
      );
    },
  },
  {
    field: "bat_speed", headerName: "Bat Speed", width: 120, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(2) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.bat_speed_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(2) : '-'}
        </Box>
      );
    },
  },
  {
    field: "ev", headerName: "EV", width: 90, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.ev_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "max_ev", headerName: "Max EV", width: 120, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.max_ev_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "max_distance", headerName: "Max Dist", width: 110,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? value.toFixed(0) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.max_distance_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined && params.value.toString() !== '-' ? params.value.toFixed(0) : '-'}
        </Box>
      );
    },
  },
  {
    field: "k_percent", headerName: "K%", width: 90, valueFormatter: (value: number) => {
      return (100 * value).toFixed(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.k_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "bb_percent", headerName: "BB%", width: 90, valueFormatter: (value: number) => {
      return (100 * value).toFixed(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.bb_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "whiff_rate", headerName: "Whiff%", width: 90, valueFormatter: (value: number) => {
      return (100 * value).toFixed(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.whiff_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "hard_hit_rate", headerName: "Hard Hit%", width: 120,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.hard_hit_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined && params.value.toString() !== '-' ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "sweet_spot_rate", headerName: "Sweet Spot%", width: 140,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.sweet_spot_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined && params.value.toString() !== '-' ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "barrel_rate",
    headerName: "Barrel%",
    width: 110,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.barrel_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "chase_rate",
    headerName: "Chase%",
    width: 110,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.chase_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "chase_rate",
    headerName: "Chase%",
    width: 120,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.chase_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "zcontact_rate",
    headerName: "ZContact%",
    width: 120,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.zcontact_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "zswing_rate",
    headerName: "ZSwing%",
    width: 120,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.zswing_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "avg_launch_angle",
    headerName: "LA",
    width: 80,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-' ? value.toFixed(1) : '-';
    }
  },
  {
    field: "swing_rate",
    headerName: "Swing%",
    width: 100,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    }
  },
  {
    field: "contact_rate",
    headerName: "Contact%",
    width: 110,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined && value.toString() !== '-'? (100 * value).toFixed(1) : '-';
    }
  },
  { field: "bb", headerName: "BB", width: 90 },
  { field: "h", headerName: "Hits", width: 90 },
  { field: "k", headerName: "K", width: 90 },
  { field: "total_swings", headerName: "Swings", width: 100 },
  { field: "total_whiffs", headerName: "Whiffs", width: 90 },
  { field: "total_swings", headerName: "Swings", width: 90 },
  { field: "total_whiffs", headerName: "Whiffs", width: 90 },
  { field: "total_zswings", headerName: "Z-Swings", width: 90 },
  { field: "total_chases", headerName: "Chases", width: 90 },
  { field: "total_zone_pitches", headerName: "Zone Pitches", width: 120 },
  { field: "total_out_of_zone", headerName: "Out of Zone Pitches", width: 150 },
];

export const pitcher_columns_mobile: GridColDef<any>[] = [
  {
    field: "pitcher_name",
    headerName: "Name",
    width: 180,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          <Link href={"/afl/player/" + params.row.id} underline="hover">
            {params.value}
          </Link>
        </Box>
      );
    },
  }, {
    field: "afl_team",
    headerName: "AFL Team",
    width: 120,
    valueGetter: (value: any) => {
      return value !== "0" && value !== 0 ? value.toString() : "FA";
    },
    valueFormatter: (value: any) => {
      return value !== "0" && value !== 0 ? value : "FA";
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = teamColors[params.value][0]

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow: "-1px -1px 0 " + teamColors[params.value][1] + ", 1px -1px 0 " + teamColors[params.value][1] + ", -1px 1px 0 " + teamColors[params.value][1] + ", 1px 1px 0 " + teamColors[params.value][1] + "",
          }}
        >
          {(params.value)}
        </Box>
      );
    },
  },
  {
    field: "MLB_AbbName",
    headerName: "Org",
    width: 80,
    valueGetter: (value: any) => {
      return value !== "0" && value !== 0 ? value.toString() : "FA";
    },
    valueFormatter: (value: any) => {
      return value !== "0" && value !== 0 ? value : "FA";
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = teamColors[params.value][0]

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: teamColors[params.value][2],
            textShadow: "-1px -1px 0 " + teamColors[params.value][1] + ", 1px -1px 0 " + teamColors[params.value][1] + ", -1px 1px 0 " + teamColors[params.value][1] + ", 1px 1px 0 " + teamColors[params.value][1] + "",
          }}
        >
          {(params.value)}
        </Box>
      );
    },
  },
  { field: "Position", headerName: "Pos", width: 80 },
  { field: "age", headerName: "Age", width: 80 },
  { field: "pa", headerName: "BF", width: 80 },
  { field: "weighted_psStuff", headerName: "psStuff+", width: 140, valueFormatter: (v: number) => v?.toFixed(1) ,
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.weighted_psStuff_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(params.value).toFixed(1)}
        </Box>
      );
    },
  },
  // --- Pitching / Stat Columns ---
  {
    field: "k_percent", headerName: "K%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.k_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "whiff_rate", headerName: "Whiff%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.whiff_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "bb_percent", headerName: "BB%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.bb_percent_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "max_velo", headerName: "Max Velo", width: 120, valueFormatter: (v: number) => v?.toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.max_velo_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value?.toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "barrel_rate", headerName: "Barrel%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.barrel_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "hard_hit_rate", headerName: "HardHit%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.hard_hit_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "woba", headerName: "wOBA", width: 80,
    valueFormatter: (value: number) => {
      return value >= 1 ? value.toFixed(3).toString() : value.toFixed(3).toString().substring(1);
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.woba_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value >= 1 ? params.value.toFixed(3).toString() : params.value.toFixed(3).toString().substring(1)}
        </Box>
      );
    },
  },
  {
    field: "ev", headerName: "EV", width: 90, valueFormatter: (value: number) => {
      return value.toString() !== '-' ? value.toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.ev_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value.toString() !== '-' ? params.value.toFixed(1) : '-'}
        </Box>
      );
    },
  },
  {
    field: "swinging_strike_rate", headerName: "SwStr%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1),
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.swinging_strike_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {(100 * params.value).toFixed(1)}
        </Box>
      );
    },
  },
  {
    field: "chase_rate",
    headerName: "Chase%",
    width: 110,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.chase_rate_p).toString();

      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  {
    field: "extension",
    headerName: "Extension",
    width: 140,
    valueFormatter: (value: number) => {
      return value !== null && value !== undefined ? (100 * value).toFixed(1) : '-';
    },
    cellClassName: (params: GridCellParams<any>) => {
      return "super-app";
    },
    renderCell: (params: GridRenderCellParams) => {
      const color = scale(params.row.extension_p).toString();
      return (
        <Box
          sx={{
            backgroundColor: color,
            width: "100%",
            height: "100%",
            textAlign: "center",
          }}
        >
          {params.value !== null && params.value !== undefined ? (100 * params.value).toFixed(1) : '-'}
        </Box>
      );
    }
  },
  { field: "k_bb_ratio", headerName: "K/BB", width: 80, valueFormatter: (v: number) => v },
  { field: "avg_launch_angle", headerName: "LA°", width: 80, valueFormatter: (v: number) => v },
  { field: "ground_ball_rate", headerName: "GB%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "fly_ball_rate", headerName: "FB%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "line_drive_rate", headerName: "LD%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "swing_rate", headerName: "Swing%", width: 80, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  
  { field: "babip", headerName: "BABIP", width: 80, valueFormatter: (v: number) => v.toString() !== '-' ? v?.toFixed(3).toString().substring(1): "-"  },
  { field: "pitches_per_pa", headerName: "Pit/PA", width: 80, valueFormatter: (v: number) => v?.toFixed(2) },
  { field: "strike_rate", headerName: "Strike%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1) },
  { field: "called_strike_rate", headerName: "CStr%", width: 90, valueFormatter: (v: number) => (100 * v).toFixed(1) },

  // --- Counting stats ---
  { field: "total_pitches", headerName: "Pitches", width: 90 },
  { field: "strikes", headerName: "Strikes", width: 80 },
  { field: "balls", headerName: "Balls", width: 80 },
  { field: "called_strikes", headerName: "Called Str", width: 90 },
  { field: "swinging_strikes", headerName: "Sw Str", width: 90 },

  { field: "total_swings", headerName: "Swings", width: 90 },
  { field: "total_whiffs", headerName: "Whiffs", width: 90 },
  { field: "bb", headerName: "BB", width: 70 },
  { field: "h", headerName: "Hits", width: 70 },
  { field: "k", headerName: "K", width: 70 },
  { field: "hr", headerName: "HR", width: 70 },
];